import { render, staticRenderFns } from "./kjnovaClipperModal.vue?vue&type=template&id=1af89ce2"
import script from "./kjnovaClipperModal.vue?vue&type=script&lang=js"
export * from "./kjnovaClipperModal.vue?vue&type=script&lang=js"
import style0 from "./kjnovaClipperModal.vue?vue&type=style&index=0&id=1af89ce2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports